{
  "No available actions": "No available actions",
  "all-rows-selected": "Selected all {{count}} rows",
  "table-subselection": "Selected {{count}} row",
  "table-subselection_plural": "Selected {{count}} rows",
  "select-all-question": ", do you want to <0>Select all {{total}} rows?</0>",
  "all-rows-selected_participants": "Selected all {{count}} participants",
  "table-subselection_participants": "Selected {{count}} participant",
  "table-subselection_participants_plural": "Selected {{count}} participants",
  "select-all-question_participants": ", do you want to <0>select all {{total}} participants?</0>"
}
